import $i from "~/i18n";
export const getComments = async (context, payload) => {
  try {
    let { data } = await axios.post("/comment/get-for-su", {
      publish: payload.publish
    });
    if (data.state != 200) return;
    context.commit("setComment", data.comments);
  } catch (error) {
    console.log(error);
  }
};

export const update = async (context, payload) => {
  try {
    let body = {
      content: payload.item.content,
      id: payload.item.id,
      publish: payload.item.published
    };
    let { data } = await axios.post("/comment/update", body);
    if (data.state != 200) return;
    context.commit(
      "notifications/success",
      { message: $i.t("message.request.done"), title: "" },
      { root: true }
    );
  } catch (error) {
    console.log(error);
  }
};
export const remove = async (context, payload) => {
  try {
    let { data } = await axios.post("/comment/delete", {
      comment_id: payload.id
    });
    if (data.state != 200) return;
    context.commit(
      "notifications/success",
      { message: $i.t("message.request.done"), title: "" },
      { root: true }
    );
  } catch (error) {
    console.log(error);
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/comments/actions.js